import { get, post } from "../../config/api";

const SERVER_URL = "";

class InventoryService {       

    static async replenish(kitchenId, replenishPayload) {
        const url = `/v3/dashboard/${kitchenId}/replenish`;
        return await post({ url, data: replenishPayload });
    }

    static async replenishWithCsv(kitchenId, replenishPayload) {
        const url = `/v3/dashboard/${kitchenId}/csv/replenish`;
        const headers = { accept: 'multipart/form-data' }
        return await post({ url, data: replenishPayload, headers });
    }

    static async undockSystem(kitchenId, data) {
        const url = `/v3/dashboard/${kitchenId}/undock`;
        return await post({ url, data });
    }

    static async replenishFromSheet(kitchenId, payload) {
        const url = `/v3/dashboard/${kitchenId}/replenish/sheet`;
        return await post({ url, data: payload })
    }

    static async validateReplenishmentPlan(kitchenId, replenishPayload) {
        const url = `/v3/dashboard/${kitchenId}/`;
        return await post({ url, data: replenishPayload})
    }

    static async searchIngredients(keyword) {
        const fields = { "_id":1,"name":1 };
        const url = `/v3/dashboard/ingredients/search?page=1&keyword=${keyword}`;
        return await post({ url, data: { fields } });
    }

    static async getInventory(kitchenId) {
        const url = `/v1/dashboard/${kitchenId}/inventory`;
        return await get({ url });
    }

}

export default InventoryService